module.exports = __webpack_public_path__ + "static/media/electrician.f76a6e4b.jpg";